import DefaultSubObjectsPanel from '../categories/common/SubObjectsPanel';
// Put a swtich here
export default function ObjectOnScreenFactory(objectType: string) {
  switch (objectType) {
    default:
      return DefaultSubObjectsPanel;
  }
}
